<template>
<v-app id="inspire"  class="movilidad">

    
        <header class="es_estatico">
        <!--IDENTIFICADOR SUPERIOR-->
        <div class="caja_verificador">
        <div class="accordion caja_acordeon" id="via_identificador">
            <div class="accordion-item">
            <button id="verificador_boton" class="accordion-header accordion-button collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#via_veridicador_contenido" aria-expanded="false"
                aria-controls="via_veridicador_contenido">
                <span>Este es un sitio web oficial del Gobierno del Estado de Nuevo León y está soportado por la Subsecretaría de Tecnologías. <a class="link">Aprende a identificarlo</a></span>
            </button>
            <div id="via_veridicador_contenido" class="accordion-collapse collapse" aria-labelledby="verificador_boton"
                data-bs-parent="#via_identificador">
                <div class="accordion-body">
                <div class="row">
                    <div class="col"><img class="logo_verificar" src="https://recursos.digital.nl.gob.mx/assets/img/logos/logo_circular.svg" alt="Logo Gobierno de NL">
                        <span> Los sitios web oficiales del Gobierno de Nuevo León están adheridos al dominio <a class="link" href="https://nl.gob.mx/" target="_blank">nl.gob.mx</a></span>
                    </div>
                    <div class="col"><img class="logo_sitio_seguro" src="https://recursos.digital.nl.gob.mx/assets/img/iconos/sellos/sitio_seguro.svg" alt="Logo de Sitio Seguro">
                        <span> Todos los sitios web oficiales del Gobierno de Nuevo León cuentan con certificado de seguridad.</span>
                    </div>
                    <div class="col"><img class="logo_via" src="https://recursos.digital.nl.gob.mx/assets/img/logos/logo_via_solo.svg" alt="Diseño VIA">
                    <span> Este sitio está conectado a <a class="link" href="https://recursos.digital.nl.gob.mx/" target="_blank">VÍA</a>, el sistema de diseño web del Gobierno de Nuevo León.</span>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>

        <!--BARRA DE NAVEGACIÓN-->
        <nav class="caja_header navbar navbar-expand-lg navbar-light">
        <div class="container-fluid">
            <div class="area_logo">
            <a class="logo_header" title="Logo Nuevo León" href="/web/Inicio"></a>
            <button id="boton_hamburguesa" class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarScroll" aria-controls="navbarScroll" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="material-icons">menu</span>
            </button>
            </div>
            <div id="navbarScroll" class="navbar-collapse collapse">
            <div class="region region-nav-main">
                <nav role="navigation" aria-labelledby="block-nlgob-main-navigation-menu" id="block-nlgob-main-navigation" class="block block-menu navigation menu--main">
                <h5 class="visually-hidden" id="block-nlgob-main-navigation-menu">Navegación principal</h5>

                <ul data-block="nav_main" class="navbar-nav navbar-nav-scroll justify-content-end flex-wrap nav-level-0">
                    <li class="menu-icon menu-icon-7 nav-item"><a @click="dialog1 = true" class="nav-link">Nosotros</a></li>
                    <li class="menu-icon menu-icon-9 nav-item"><a href="/web/Concursos" class="nav-link">Concursos</a></li>
                    <li class="menu-icon menu-icon-8 nav-item"><a href="/web/historicocontratospublicos" class="nav-link">Historico de Contratos</a></li>
                    <li class="menu-icon menu-icon-10 nav-item"><a href="https://proveedores.nl.gob.mx/" target="_blank" class="nav-link">Registro Proveedores</a></li>
                    <li class="menu-icon menu-icon-11 nav-item"><a @click="dialog = true" class="nav-link">Recibe Notificaciones</a></li>
                </ul>

                </nav>
            </div>
            </div>
        </div>
        </nav>
        <!-- <div class="mr-3 d-block d-lg-none">
            <v-app-bar-nav-icon @click.stop="show"></v-app-bar-nav-icon>
        </div> -->
        <v-dialog v-model="dialog1" max-width="1100">
                <v-card>
                    <v-card-title class="headline grey lighten-2">
                        <h4> Nosotros | Secretaría de Movilidad y Planeación Urbana</h4>
                    </v-card-title>
                    <v-card-text>
                        <div class="modal-body mb-0 text-center">
                            <div class="mt-4 text-center">
                                <img src="https://smpu.nl.gob.mx/acceso/assets/smpu.png" style="max-width: 50%;" />
                            </div>
                            <div class="row">
                                 <!--<div class="col-lg-6 col-sm-12">
                                    <h3 class="titulos">Visión</h3>
                                    <br />
                                    <p>
                                        Trascender como la primera dependencia de un gobierno independiente reconocida a nivel nacional por su
                                        modelo competitivo y de transparencia total, garantizando el uso óptimo de los recursos públicos.
                                    </p>
                                </div>
                                <div class="col-lg-6 col-sm-12">
                                    <h3 class="titulos">Misión</h3>
                                    <br />
                                    <p>
                                        Desarrollar obra pública de alta calidad, incluyente y de beneficio social para los habitantes de Nuevo León,
                                        con eficiencia, innovación, honestidad y transparencia, atrayendo inversiones y consolidando a nuestro estado como el mejor lugar para vivir.
                                    </p>
                                </div>
                                <div class="col-lg-6 col-sm-12">
                                    <h3 class="titulos">Responsabilidades</h3>
                                    <br />
                                    <p>Dependencia encargada de la proyección y construcción de las obras públicas que conciernen a la Administración Pública del Estado.</p>
                                </div>
                                <div class="col-lg-6 col-sm-12">
                                    <h3 class="titulos">Prioridades</h3>
                                    <br />
                                    <p>
                                        Satisfacer las necesidades de los habitantes de Nuevo León en la creación, conservación y mejoramiento de la Infraestructura del estado,
                                        con calidad, seguridad y transparencia, en un marco de sustentabilidad y respeto al medio ambiente.
                                    </p>
                                </div>-->
                                <div class="col-12">
                                    <div><img src="https://nl.gob.mx/sites/default/files/2023-09/Hern%C3%A1n%20Manuel%20Villarreal%20Rodr%C3%ADguez.jpg" style="border-radius:15%; max-width: 35%;" /></div>
                                    <h3 style="font-family: 'Maven Pro', sans-serif; font-size: 24px;" >Hernán Villarreal Rodríguez</h3><br>
                                    <h4 style="font-family: 'Maven Pro', sans-serif; font-size:1.5em; font-weight:600;">Secretario de Movilidad y Planeación Urbana</h4>
                                    <br />
                                    <h3 class="titulos">Responsabilidades de esta dependencia</h3>
                                    <br />
                                    <p>
                                        Formular, conducir, planear y evaluar la política de movilidad mediante la responsabilidad de conservar y asegurar que las necesidades de tráfico protejan el bienestar y seguridad social de los ciudadanos; el desarrollo urbano estatal implementará una mejor estrategia de planeación en la distribución de la urbanización; y de la proyección y construcción de las obras públicas teniendo como objetivo el beneficio social de la población y el crecimiento económico del Estado, que le conciernen a las dependencias de la Administración Pública del Estado.
                                    </p>
                                     <!--<h3 class="titulos">Organigrama</h3>

                                    <v-img v-bind="attrs" v-on="on" max-width="1000" src="https://www.nl.gob.mx/sites/default/files/10.infraestructura.jpg">
                                    </v-img>

                                    <div style="text-align:left" class="container">
                                        <v-btn color="blue" small height="50" width="280" class="ma-1 " href="https://www.nl.gob.mx/funcionarios/silvia-vargas-villarreal" target="_blank">
                                            Secretaría Particular
                                        </v-btn> <br>
                                        <v-btn color="blue" small height="50" width="280" class="ma-1 " href="https://www.nl.gob.mx/funcionarios/rafael-salgado-garcia" target="_blank">
                                            Secretaría Técnica
                                        </v-btn><br>
                                        <v-btn color="blue" small height="50" width="280"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/lorenzo-javier-zamarron-gutierrez" target="_blank">
                                            Dirección de Transparencia <br> y Normatividad
                                        </v-btn><br>
                                        <v-btn color="blue" small height="50" width="280"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/jorge-alberto-tovar-nicoli" target="_blank">
                                            Unidad de Inversiones 
                                        </v-btn><br>
                                        <v-btn color="blue" small height="50" width="280"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/rosa-amelia-lozano-zambrano" target="_blank">
                                            Subsecretaría de Construcción
                                        </v-btn><br>
                                        <v-row>
                                            <v-col>
                                                <v-btn color="blue" outlined small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/sandra-guadalupe-patino-macias" target="_blank">
                                                    Dirección de Proyectos
                                                </v-btn>
                                            
                                                <v-btn color="blue" outlined  small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/leonel-botello-de-leon" target="_blank">
                                                    Dirección de Edificación
                                                </v-btn>
                                        
                                                <v-btn color="blue" outlined  small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/jose-eleuterio-garcia-velazquez" target="_blank">
                                                    Dirección de Obras Especiales
                                                </v-btn>
                                            </v-col>
                                        </v-row>

                                        <v-btn color="blue" small height="50" width="280"   class="ma-1 " href="https://www.nl.gob.mx/funcionarios/godofredo-gardner-anaya" target="_blank">
                                            Subsecretaría de Planeación
                                        </v-btn>
                                        <v-row>
                                            <v-col>
                                                <v-btn color="blue" outlined  small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/alejandro-sanchez-gomez" target="_blank">
                                                    Dirección de Licitaciones
                                                </v-btn>
                                            
                                                <v-btn color="blue" outlined small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/noemi-gutierrez-moreno" target="_blank">
                                                    Unidad de Enlace Administrativo
                                                </v-btn>
                                            
                                                <v-btn color="blue" outlined small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/alfonso-salazar-lopez" target="_blank">
                                                    Dirección de Planeación, <br> Programación y Presupuesto
                                                </v-btn>
                                            
                                                <v-btn color="blue" outlined small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/maria-eugenia-gonzalez-monreal" target="_blank">
                                                    Dirección de Bienestar Ciudadano
                                                </v-btn>
                                                <v-btn color="blue" outlined small height="40" width="270"  class="ma-1 " href="https://www.nl.gob.mx/funcionarios/jesus-antonio-galindo-gutierrez" target="_blank">
                                                    Dirección de Innovación y <br> Mejora Continua de Procesos
                                                </v-btn>
                                            </v-col>
                                        </v-row>-->
                                    </div> 
                                </div>
                            </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="dialog1 = false">
                            salir
                        </v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" width="900">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    <h4> Recibe Notificaciones</h4>
                </v-card-title>
                <v-card-text>
                    <div class="modal-body mb-0 text-center">
                        <div class="row">
                            <div class="col-lg-6 col-sm-12">
                                <v-text-field v-model="Ciudadanos.Email" :rules="[rules.required, rules.email]" name="Email" label="Correo electronico" id="id"></v-text-field>
                                <v-text-field v-model="Ciudadanos.NombreCiudadano" :rules="[rules.required , rules.texto]" name="Nombre" label="Nombre" id="id"></v-text-field>
                                <v-text-field v-model="Ciudadanos.PrimerApellido" :rules="[rules.required, rules.texto]" name="Apellido" label="Apellido" id="id"></v-text-field>
                            </div>
                        </div>
                        <br />
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined @click="cerrar()">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="GuardarCiudadano()">
                        Registrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </header>
    <!-- <v-toolbar width="100%" height="35" max-height="35" class="pt-1 pb-1" style="background-color:#f2f2f2">

      <div class="mr-3" style="text-align:center">
      </div>

    </v-toolbar> -->



    <v-content>

        <!-- <div>
              <Mapa class="mapa"/>
            </div> -->
        <v-container class="ma-0 pa-0" fluid>
            <v-slide-y-transition mode="out-in">
                <router-view />

            </v-slide-y-transition>

        </v-container>
        <br>
    </v-content>
    <footer>
  <section class="seccion_enlaces">
    <div class="caja_enlaces">
      <div class="area_enlaces">
        <div class="col">
          <a class="nav-link" href="https://www.nl.gob.mx/es/gobierno" target="_blank">Gobierno</a>
          <a class="nav-link" href="https://www.nl.gob.mx/es/nlinea" target="_blank">Trámites y Servicios</a>
          <a class="nav-link" href="https://nl.gob.mx/transparencia" target="_blank">Transparencia</a>
        </div>
        <div class="col">
          <a class="nav-link" href="https://www.nl.gob.mx/es/codigodeetica" target="_blank">Código de ética</a>
          <a class="nav-link" href="https://app.st.nl.gob.mx/incorruptible/RegEmp.aspx" target="_blank">Denuncia Ciudadana</a>
          <a class="nav-link" href="https://smpu.nl.gob.mx/transparencia" target="_blank">Infraestructura Abierta</a>
        </div>
      </div>
      <div class="escudo_enlaces">
        <img
          src="https://recursos.digital.nl.gob.mx/assets/img/logos/logo_circular.svg"
          title="Escudo circular de Nuevo León"
          alt="Escudo circular de Nuevo León"
          loading="lazy"/>
      </div>
    </div>
  </section>
  <section class="seccion_redes">
    <div class="caja_redes">
      <div class="area_escudo">
        <div class="logo_secretaria"></div>
        <div class="leyenda_avisos">
          <a class="link" href="https://www.nl.gob.mx/es/sobre-tratamiento-datos-personales" target="_blank" rel="noopener noreferrer">Sobre el tratamiento de datos personales</a>|
          <a class="link" href="https://www.nl.gob.mx/es/formulario/opinion" target="_blank" rel="noopener noreferrer">Consulta el Aviso de Privacidad</a>
        </div>
      </div>
      <div class="area_redes">
        <div class="leyenda_redes">Manténte informado:</div>
        <a href="https://www.facebook.com/SMovilidadNL" title="¡Síguenos en Facebook!"><img
            src="https://recursos.digital.nl.gob.mx/assets/img/iconos/redes_sociales/facebook.svg"
            alt="Gobierno de Nuevo León en facebook" /></a>
        <a href="https://www.instagram.com/smovilidadnl/" title="¡Síguenos en Instagram!"><img
            src="https://recursos.digital.nl.gob.mx/assets/img/iconos/redes_sociales/instagram.svg"
            alt="Gobierno de Nuevo León en instagram" /></a>
        <a href="https://x.com/SMovilidadNL?t=oByl5lGsTsur_SZkqsV-7w&s=09" title="¡Síguenos en X!"><img
            src="https://recursos.digital.nl.gob.mx/assets/img/iconos/redes_sociales/twitter.svg"
            alt="Gobierno de Nuevo León en twitter" /></a>
        <a href="https://t.me/gobnl" title="¡Síguenos en Telegram!"><img
            src="https://recursos.digital.nl.gob.mx/assets/img/iconos/redes_sociales/telegram.svg"
            alt="Gobierno de Nuevo León en telegram" /></a>
        <a href="https://www.tiktok.com/@nuevonlmx" title="¡Síguenos en Tiktok!"><img
            src="https://recursos.digital.nl.gob.mx/assets/img/iconos/redes_sociales/tiktok.svg"
            alt="Gobierno de Nuevo León en tiktok" /></a>
        <a href="https://www.youtube.com/user/GobiernoNuevoLeon" title="¡Síguenos en Youtube!"><img
            src="https://recursos.digital.nl.gob.mx/assets/img/iconos/redes_sociales/youtube.svg"
            alt="Gobierno de Nuevo León en youtube"/></a>
      </div>
    </div>
  </section>
  <section class="seccion_leyenda">
    <div class="primera_leyenda">Gobierno de <strong>nuevo león</strong></div>
    <div class="logo_leyenda">
      <img
        src="https://recursos.digital.nl.gob.mx/assets/img/logos/logo_leondorado.svg"
        alt="logo de león dorado"
      />
    </div>
    <div class="segunda_leyenda">Un <strong>nuevo</strong> nuevo león</div>
  </section>
  <section class="seccion_licencia">
    <p>SOPORTADO POR
      <a class="link" href="https://recursos.digital.nl.gob.mx/" target="_blank">VÍA SISTEMA DE DISEÑO</a> 
      ©2024 DE LA
      <a class="link" href="http://ruta.digital.nl.gob.mx/" target="_blank"> SUBSECRETARÍA DE TECNOLOGIAS</a> 
      BAJO LICENCIA
      <a class="link" href="https://creativecommons.org/licenses/by-nc-sa/4.0/?ref=chooser-v1" target="_blank">CC BY-NC-SA 4.0</a>
    </p>
  </section>
</footer>
</v-app>
</template>

<!-- Global site tag (gtag.js) - Google Analytics -->

<script async src="https://www.googletagmanager.com/gtag/js?id=UA-120666640-2"></script><script>
window.dataLayer = window.dataLayer || [];

function gtag() {
    dataLayer.push(arguments);
}
gtag('js', new Date());

gtag('config', 'UA-120666640-2');
</script><script>
import Inicio from './components/Inicio';
import axios from 'axios'
export default {
    name: 'App',

    props: {
        //source: String,
    },
    menuProveedores: false,

    components: {
        Inicio
    },

    data: () => ({
        rules: {
            required: value => !!value || 'Campo requerido.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Formato de correo no valido.'
            },
            texto: value => {
                const pattern = /\W/g
                return !pattern.exec(value) || 'Caracter no valido'
            },
        },
        showMenu: false,
        x: 0,
        y: 0,
        dialog: false,
        dialog1: false,
        overlay: false,
        items: [{
                title: 'Suscribete',
                link: 'proveedores.nl.gob.mx/'
            },
            {
                title: 'Recibe Notificaciones',
                link: 'proveedores.nl.gob.mx/'
            },
        ],

        Ciudadanos: {
            NombreCiudadano: '',
            PrimerApellido: '',
            Email: ''
        },

    }),
    computed: {
        accesoRegistrado() {
            return this.$store.state.usuario;
        }

    },
    created() {
        //this.$store.dispatch("autoLogin");
    },

    methods: {
        show(e) {
            e.preventDefault()
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
        },

        salir() {

            this.$store.dispatch("salir");
            location.reload();
        },
        GuardarCiudadano() {

            let me = this;
            console.log('Envia Parametros', me.Ciudadanos);
            axios.post('api/Ciudadanos/Crear', me.Ciudadanos).then(function (response) {
                me.cerrar();
                alert("Se guardó la informacion correctamente");

            }).catch(function (error) {
                console.log(error);
            });
        },
        cerrar() {
            let me = this;
            me.dialog = false;
            me.limpiar();
        },
        limpiar() {
            let me = this;
            me.Ciudadanos.NombreCiudadano = '';
            me.Ciudadanos.PrimerApellido = '';
            me.Ciudadanos.Email = '';
        }
    }
};
</script>
